import { Component, createRef } from 'react';
import PropTypes from 'prop-types';

/** Components */
import MathquillInput from './MathquillInput';

import KeypadLayoutFactory from './layouts/KeypadLayoutFactory';

class EquationEditor extends Component {
  // Controls a multi-line editor interface, where each line
  // is a MathquillInput.
  constructor(props) {
    super(props);
    // The active MathquillInput is stored as this.activeInput
    this.activeInput = createRef();
  }

  handleChange = () => {
    this.props.onChange(this.activeInput.current.latex());
  };

  handleInputClick = (index) => {
    this.props.onInputClick(index);
  };

  handleKeyUp = (e) => {
    if (e.key === 'Enter') {
      if (this.props.showNavWhenActive) {
        this.props.onNavDown();
      } else {
        this.props.onClose();
      }
    } else {
      this.handleChange();
    }
  };

  handleKeypadPressCmd = (commands) => {
    commands.forEach((commandStr) => this.activeInput.current.cmd(commandStr));
    this.handleChange();
  };

  handleKeypadPressWrite = (value) => {
    this.activeInput.current.write(value);
    this.handleChange();
  };

  triggerKeystroke = (value) => {
    this.activeInput.current.keystroke(value);
    this.handleChange();
  };

  render() {
    const mathquillInputs = this.props.equations.map((equation, i) => {
      const ref = i === this.props.activeEquation ? this.activeInput : null;

      return (
        <MathquillInput
          key={i}
          ref={ref}
          index={i}
          equations={this.props.equations}
          activeEquation={this.props.activeEquation}
          onKeyUp={this.handleKeyUp}
          onNavUp={this.props.onNavUp}
          onNavDown={this.props.onNavDown}
          onClick={this.handleInputClick}
          showNavWhenActive={this.props.showNavWhenActive}
        />
      );
    });

    // Delegate keyboard creation to our factory method
    const keypadLayout = KeypadLayoutFactory.create(this.props.keypadLayout, {
      onTriggerKeystroke: this.triggerKeystroke,
      onKeyPressWrite: this.handleKeypadPressWrite,
      onKeyPressCmd: this.handleKeypadPressCmd,
    });

    return (
      <div className="equation-editor">
        <div className="input-container">{mathquillInputs}</div>
        {keypadLayout}
      </div>
    );
  }
}

EquationEditor.propTypes = {
  equations: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeEquation: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onInputClick: PropTypes.func.isRequired,
  onNavUp: PropTypes.func.isRequired,
  onNavDown: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  keypadLayout: PropTypes.string.isRequired,
  showNavWhenActive: PropTypes.bool,
};

EquationEditor.defaultProps = {
  showNavWhenActive: true,
};

export default EquationEditor;
